<template>
  <div v-if="hasSelectedCards">
    <div v-if="isMobileCardsOpen" id="mobile-card-mask"></div>

    <div id="comparison-container">
      <div v-if="isMobileCardsOpen" class="mobile-cards-list +bg-white">
        <card
          v-for="(cardObject, index) in cards"
          :key="index"
          :card="cardObject"
        ></card>
      </div>

      <div id="main-drawer-container" class="+bg-white">
        <div
          v-if="!isMobile"
          class="grid page-wrapper --align-middle +pd-bottom-md +pd-left-md +pd-right-md"
        >
          <div class="grid-cell size-2of3--md +pd-top-md">
            <div class="grid --align-middle">
              <div class="grid-cell size-1of5">
                <div class="+heading-zeta">Selected:</div>
                <div class="+heading-epsilon">
                  {{ cardSelectedCount }} of {{ maxCardsAllowed }} Cards
                </div>
              </div>

              <card
                v-for="(cardObject, index) in cards"
                :key="index"
                :card="cardObject"
              ></card>
            </div>
          </div>
          <div class="grid-cell size-1of3--md +pd-top-md">
            <div class="grid --align-middle">
              <div class="grid-cell size-3of4 +pd-left-md">
                <a
                  :class="[
                    { '--is-disabled': !comparable },
                    'button --primary --full-width media --align-middle media-middle --reverse'
                  ]"
                  :href="compareUrl"
                >
                  <span class="media-body media__body ">COMPARE</span>
                  <span
                    class="media-object media__figure icon --sm +mg-left-xs"
                    style="margin-top: -3px;"
                  >
                    <svg
                      class="icon__glyph"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="590 -500 1792 1792"
                      style="enable-background:new 590 -500 1792 1792;"
                      xml:space="preserve"
                    >
                      <g>
                        <path
                          d="M1211,876c0-8.7,3.3-16.3,10-23l393-393L1221,67c-6.7-6.7-10-14.3-10-23s3.3-16.3,10-23l50-50c6.7-6.7,14.3-10,23-10
                                                          s16.3,3.3,23,10l466,466c6.7,6.7,10,14.3,10,23s-3.3,16.3-10,23l-466,466c-6.7,6.7-14.3,10-23,10s-16.3-3.3-23-10l-50-50
                                                          C1214.3,892.3,1211,884.7,1211,876z"
                          fill="#ffffff"
                        ></path>
                      </g>
                      <g>
                        <path
                          d="M1559.3,526.9l-828.7,0c-9.4,0-17.2-3.1-23.3-9.2c-6.1-6.1-9.2-13.9-9.2-23.3v-70.7c0-9.4,3.1-17.2,9.2-23.3
                                                          s13.9-9.2,23.3-9.2l932,0c9.4,0,17.2,3.1,23.3,9.2c6.1,6.1,9.2,114.3,9.2,123.7L1559.3,526.9z"
                          fill="#ffffff"
                        ></path>
                        <path d="M1783,483" fill="#ffffff"></path>
                      </g>
                    </svg>
                  </span>
                </a>
              </div>
              <div class="grid-cell size-1of4 +text-center">
                <a
                  class="button --bare +pd-left-md +pd-right-md +fg-gray-dark +text-size-sm"
                  @click="clearCards"
                >
                  RESET
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="isMobile"
          class="+pd-top-xs +pd-bottom-xs +pd-left-sm +pd-right-sm"
        >
          <div class="grid --with-gutter --align-middle --equal-height">
            <div class="grid-cell size-1of4">
              <button
                class="mobile-card-count-container"
                @click="toggleMobileCards"
              >
                <svg
                  class="cc-count-svg icon__glyph"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="38px"
                  height="24px"
                  viewBox="0 0 38 24"
                >
                  <g
                    id="Page-1"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <g
                      id="creditcard-alone-icon-outline"
                      transform="translate(-9.000000, -18.000000)"
                      fill="#3139F2"
                      fill-rule="nonzero"
                    >
                      <g transform="translate(9.000000, 18.000000)" id="Shape">
                        <path
                          d="M1,5.7 L37,5.7 L37,3.309472 C37,2.03398583 35.9660142,1 34.690528,1 L3.309472,1 C2.03398583,1 1,2.03398583 1,3.309472 L1,5.7 Z M37,10.2 L1,10.2 L1,20.690528 C1,21.9660142 2.03398583,23 3.309472,23 L34.690528,23 C35.9660142,23 37,21.9660142 37,20.690528 L37,10.2 Z M1,6.7 L1,9.2 L37,9.2 L37,6.7 L1,6.7 Z M3.309472,0 L34.690528,4.4408921e-16 C36.5182989,1.25899423e-16 38,1.48170108 38,3.309472 L38,20.690528 C38,22.5182989 36.5182989,24 34.690528,24 L3.309472,24 C1.48170108,24 1.59094893e-16,22.5182989 0,20.690528 L4.4408921e-16,3.309472 C2.84994317e-16,1.48170108 1.48170108,3.18189787e-16 3.309472,0 Z"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>

                <span class="mobile-card-count +bg-white +center-content">{{
                  cardSelectedCount
                }}</span>
              </button>
            </div>
            <div class="grid-cell size-7of12">
              <a
                style="height: 42px;"
                :class="[
                  { '--is-disabled': !comparable },
                  'button --primary --full-width +pd-top-xxs +pd-bottom-xxs'
                ]"
                :href="compareUrl"
                @click="trackCompare"
              >
                COMPARE
              </a>
            </div>
            <div class="grid-cell size-2of12 +text-right">
              <button
                @click="clearCards"
                class="mobile-close-drawer button --bare +pd-none +pd-top-xxs +pd-bottom-xxs"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 320 512"
                  class="svg-card-close"
                >
                  <path
                    fill="currentColor"
                    d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"
                    class=""
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from './card'
import utilities from 'apps/utility/vue-common'

export default {
  components: {
    Card
  },

  data() {
    return {
      mobileCards: false
    }
  },

  computed: {
    hasSelectedCards() {
      return this.cardSelectedCount > 0
    },
    cardSelectedCount() {
      return Object.keys(this.cards).length
    },
    maxCardsAllowed() {
      return this.$store.getters.maxCardsAllowed
    },
    cards() {
      return this.$store.getters.cardsForComparison
    },
    comparable() {
      return this.$store.getters.isComparable
    },
    compareUrl() {
      return this.$store.getters.compareUrl
    },
    isMobile() {
      return utilities.methods.isMobile()
    },
    isMobileCardsOpen() {
      return this.mobileCards
    }
  },

  methods: {
    clearCards() {
      this.$store.dispatch('resetCards')
      this.mobileCards = false

      const tagular = window.tagular
      if (typeof tagular !== 'undefined') {
        tagular('beam', 'ElementClicked', {
          '@type': 'redventures.usertracking.v3.ElementClicked',
          webElement: {
            location: 'Compare',
            position: 'Footer',
            elementType: 'Button',
            text: 'Reset',
            htmlId: ''
          },
          actionOutcome: '',
          outboundUrl: ''
        })
      }
    },
    toggleMobileCards() {
      this.mobileCards = !this.mobileCards

      const tagular = window.tagular
      if (typeof tagular !== 'undefined') {
        tagular('beam', 'ElementClicked', {
          '@type': 'redventures.usertracking.v3.ElementClicked',
          webElement: {
            location: 'Compare',
            position: 'Footer',
            elementType: 'Button',
            text: 'Card Icon',
            htmlId: ''
          },
          actionOutcome: '',
          outboundUrl: ''
        })
      }
    },
    trackCompare() {
      const tagular = window.tagular
      if (typeof tagular !== 'undefined') {
        tagular('beam', 'ElementClicked', {
          '@type': 'redventures.usertracking.v3.ElementClicked',
          webElement: {
            location: 'Compare',
            position: 'Footer',
            elementType: 'Button',
            text: 'Compare',
            htmlId: ''
          },
          actionOutcome: '',
          outboundUrl: this.compareUrl()
        })
      }
    }
  }
}
</script>

<!-- eslint-disable -->
<style lang="scss" scoped>
@import './../../../../sass/brcom/settings/_settings.theme-colors.scss';

#card-compare-drawer {
  font-family: "Calibre-Regular",Arial,sans-serif;
}
#comparison-container {
  z-index: 1000;
  position: fixed;
  bottom: 0;
  width: 100%;
}
#main-drawer-container {
  border-top: 3.5px solid $theme-blue-light
}
#mobile-card-mask {
  background: rgba(0, 0, 0, 0.3);
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}
.mobile-card-count-container {
  position: relative;
  display: inline-block;
  padding-right: 10px;
}
.mobile-card-count-container svg.cc-count-svg {
  height: 42px;
  width: 63px;
}
.mobile-card-count {
  position: absolute;
  border-radius: 50%;
  border: 2px solid $theme-blue;
  line-height: 24px;
  font-size: 22px;
  top: -6px;
  right: 3px;
  height: 30px;
  width: 30px;
  text-align: center;
  color: $theme-blue;
}
.mobile-close-drawer {
  height: 42px;
  width: 42px;
}
.mobile-close-drawer svg {
  width: 28px;
  height: 28px;
  color: $theme-gray-darker;
}
.mobile-cards-list {
  border-top: 1px solid $theme-gray;
}
</style>
<!-- eslint-enable -->
